import React from "react";

const ShareIcon = ({ fillColor }: { fillColor: string }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.83 0.13C10.52 -0.16 9.99 0.06 9.99 0.50V5.34C8.74 5.42 7.62 5.64 6.59 6.07C5.29 6.61 4.21 7.46 3.26 8.66C2.27 9.91 1.59 11.98 1.17 13.59C0.62 15.69 0.33 17.85 0 20C0.94 18.93 1.85 17.80 2.89 16.82C4.79 15.02 7.29 13.35 9.99 13.30V18.12C9.99 18.56 10.52 18.79 10.83 18.48L20.43 9.31L10.83 0.13ZM9.99 11.30L11.99 11.30V14.59L17.51 9.31L11.99 4.03V7.31L10.99 7.31C9.50 7.31 8.33 7.50 7.36 7.91C6.40 8.31 5.59 8.94 4.83 9.89C4.13 10.77 3.55 12.42 3.13 14.01C5.10 12.52 7.47 11.34 9.99 11.30Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default ShareIcon;
